// src/plugins/posthog.js
import posthog from "posthog-js";

export default {
	install(app) {
		if (window.location.hostname === "brands.partneruphub.com") {
			posthog.init("phc_gYksvc1hs5bbwSn4ZfrH7HXigxIdJ01KTuEOQKBKedt", {
				api_host: "https://p.partneruphub.com",
				defaults: "2026-01-30",
				person_profiles: "identified_only",
				capture_pageview: false,
			});

			app.config.globalProperties.$posthog = posthog;
		}
		if (window.location.hostname === "brands-dev.partneruphub.com" || window.location.hostname === "brands-demo.partneruphub.com") {
			posthog.init("phc_sDeFmUvHiVW95km4duvNESH7iuixPg4vyL2b5Gb2Qpw", {
				api_host: "https://p.partneruphub.com",
				defaults: "2026-01-30",
				person_profiles: "identified_only",
				capture_pageview: false,
			});

			app.config.globalProperties.$posthog = posthog;
		}
	},
};
